import { render, staticRenderFns } from "./KYCRequestStatusBadge.vue?vue&type=template&id=f60e6e18"
import script from "./KYCRequestStatusBadge.vue?vue&type=script&lang=js"
export * from "./KYCRequestStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports